import { authApi } from "./auth";
import { mainServiceURL } from "./defines";

export const profileApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchProfile: builder.query({
      query: () => mainServiceURL + `/users`,
      providesTags: ["Profile"],
    }),
    updateUser: builder.mutation({
      query: (user) => ({
        url: mainServiceURL + `/users`,
        method: "PUT",
        body: user,
      }),
      invalidatesTags: ["Profile"],
    }),
    completeSignup: builder.mutation({
      query: () => ({
        url: mainServiceURL + "/users/complete-sign-up",
        method: "POST",
      }),
      invalidatesTags: ["Profile"],
    }),
    activateUser: builder.mutation({
      query: (query) => ({
        url: mainServiceURL + "/users/activate",
        method: "PUT",
        body: query,
      }),
    }),
    updatePassword: builder.mutation({
      query: () => ({
        url: mainServiceURL + `/users/password`,
        method: "PUT",
      }),
    }),
  }),
});

export const {
  useFetchProfileQuery,
  useLazyFetchProfileQuery,
  useUpdateUserMutation,
  useActivateUserMutation,
  useCompleteSignupMutation,
  useUpdatePasswordMutation,
} = profileApi;
